import React from 'react';
import './AboutUs.css';
import { useState } from "react";
import { useTranslation } from "react-i18next";

function AboutUs() {
    const { t } = useTranslation();
    return (
        <div className="about-us-section">
            <h1>About us</h1>
            <p className="about-us-text"> {t('Welcome to Abougabal Constructions. Together we will design and materialize your dream house, working place, or business premises. Since 2004, we undertake housing and business constructions, as well as real estate renovations and hotels in Athens, Greek Islands, Mainland Greece and Cyprus.')}</p>
            {/*<a className="about-us-btn" href="/company">{t('Read more')} &gt;</a>*/}
        </div>
    );
}

export default AboutUs;
